import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dashboard-admin',
    templateUrl: './dashboard-admin.component.html',
    styleUrls: ['./dashboard-admin.component.scss'],
    standalone: false
})
export class DashboardAdminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
